import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getIsaFundClassifications, saveBatchIsaFundClassifications } from '../../api/isaFundClassifications';
import type { IsaFundClassification } from '../../types/IsaFundClassification';
import { t } from '../../i18n/t';

const columnDefs: ColDef<IsaFundClassification>[] = [
  {
    field: 'isaFundClassificationId',
    headerName: t('isaFundClassifications.columns.isaFundClassificationId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<IsaFundClassification>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'isaFundClassificationName', headerName: t('isaFundClassifications.columns.isaFundClassificationName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<IsaFundClassification> => ({ isaFundClassificationId: 0, isaFundClassificationName: '' });

export function IsaFundClassificationsPage() {
  return (
    <LopCrudPage<IsaFundClassification>
      resourceCode="isaFundClassifications"
      titleKey="isaFundClassifications.pageTitle"
      idField="isaFundClassificationId"
      getRows={getIsaFundClassifications}
      saveBatch={(added, modified, deletedIds) => saveBatchIsaFundClassifications(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
